(ns portal.advertiser-configuration-page.db.core
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def entity-name "Advertiser")

(defn url?
  [s]
  (re-matches #"^(https?://.+)$" s))

(spec/def ::name
  (spec/and string?
            (complement str/blank?)))

(spec/def ::code
  (spec/and string?
            (complement str/blank?)))

(spec/def ::backupLandingPageUrl
  (spec/and (complement str/blank?)
            url?))

(spec/def ::value
  (spec/keys :req-un [::name ::code ::backupLandingPageUrl]))

(p/defphraser (complement str/blank?)
  [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser string?
  [_ problem key]
  {:message "The field should be a string"
   :in (:in problem)
   :problem problem})

(p/defphraser url?
  [_ problem]
  {:message "The field should be a valid URL"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.advertiser-configuration ::value)))

(def forward-events
  [{:events #{:resource.advertiser/patch-success}
    :dispatch-to [:form.advertiser-configuration/submit-success]}
   {:events #{:resource.advertiser/patch-failure}
    :dispatch-to [:form.advertiser-configuration/submit-failure]}])

(rf/reg-event-fx :page.advertiser-configuration/init
  (fn [_ _]
    {:fx [[:dispatch [:form.advertiser-configuration/init]]
          [:dispatch [:form.whitelist/init]]]}))

(rf/reg-event-fx :page.advertiser-configuration/destroy
  (fn [_ _]
    {:fx [[:dispatch [:form.advertiser-configuration/destroy]]
          [:dispatch [:form.whitelist/destroy]]]}))

(form/register-form {:namespace :form.advertiser-configuration
                     :validate-form validate-form
                     :forward-events forward-events
                     :submit-event :form.advertiser-configuration/submit-form})

(rf/reg-event-db :form.advertiser-configuration/set-initial-value
  [validate-form]
  (fn [db [_ advertiser]]
    (-> db
        (assoc-in [:form.advertiser-configuration :value] advertiser)
        (assoc-in [:form.advertiser-configuration :meta] {:initial advertiser}))))

(rf/reg-event-fx :form.advertiser-configuration/submit-form
  (fn [{:keys [db]} [_ payload]]
    {:db (assoc-in db [:form.advertiser-configuration :state]
                   {:status :pending})
     :dispatch-n [[:loader/open]
                  [:resource.advertiser/patch
                   (select-keys payload [:name :code :backupLandingPageUrl :interactionTrackingEnabled])]]}))

(rf/reg-event-fx :form.advertiser-configuration/submit-success
  (fn [_ [_ [_ advertiser]]]
    {:fx [[:dispatch [:loader/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :success
                       :message "Successfully saved advertiser"}]]
          [:invalidate-queries {:queryKey ["advertiser" (:id advertiser)]}]]}))

(rf/reg-event-fx :form.advertiser-configuration/submit-failure
  (fn [_ [event error-response]]
    {:dispatch-n [[:loader/close]
                  [:response-handler/handle-response
                   {:entity-name entity-name
                    :type :error
                    :event event
                    :message "Failed to save advertiser"
                    :response error-response}]]}))

(rf/reg-event-db :form.advertiser-configuration/reset-state
  (fn [db]
    (update-in db [:form.advertiser-configuration] dissoc :state)))

(rf/reg-sub :form.advertiser-configuration/backend-error
  (fn [db]
    (get-in db [:form.advertiser-configuration :backend-error])))

(def use-bind-control (partial form/use-bind-control :form.advertiser-configuration))
(def use-error-message (partial form/use-error-message :form.advertiser-configuration))
